import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_104: FaireProductEntity = {
  token: "starter_collection_104",
  type: "product",
  name: "Niko Tumbler Tall",
  brandName: "Be Home",
  imageUrl:
    '"https://cdn.faire.com/fastly/41df6326cb9ae5326b387ce36307d6648c7b66841d62c65c823225874d042913.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1404',
  priceDollars: 16,
  msrpDollars: 32,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
